import { EvergabeWhitepaper } from "components/page-components/Evergabe"
import {
  AngebotswertungAccordionTabs,
  FomularsätzeAccordionTabs,
} from "data/page-content/evergabe/product"

import { Accordion } from "components/page-components/Info-Modules"
import { GatsbyImage } from "gatsby-plugin-image"
import { Layout } from "components/structure-components/layout"
import { Link } from "gatsby"
import React from "react"
import { SEOComponent } from "components/seo-components"
import { graphql } from "gatsby"
import { Sparkles } from "components/page-components/Particles"
import { CheckmarkIcon } from "components/page-components/Icons/small"

const ProduktEvergabe = ({ location, data }) => {
  const {
    angebotsbewertungImage,
    bieterkommunikationImage,
    dokumentierenImage,
    integrierteFormulareImage,
    termineUndFristenImage,
    uebermittlungTedImage,
    veroeffentlichungAufKnopfdruckImage,
    vergabestatistikImage,
    header_illustration,
    ceoImage,
    evSocialProofingImages,
    signatureMockup,
    sales_headshot,
  } = data
  const breadcrumb_array = [
    {
      type: "BreadcrumbLink",
      content: `B_I MEDIEN`,
      link: `/`,
      react_key: "footer_breadcrumb_item_0",
      ressort: "evergabe",
    },
    {
      type: "BreadcrumbLink",
      content: `Aufträge vergeben`,
      link: `/evergabe`,
      react_key: "footer_breadcrumb_item_1",
      ressort: "evergabe",
    },
    {
      type: "BreadcrumbSpan",
      content: "Produkt",
      link: ``,
      react_key: "footer_breadcrumb_item_4",
      ressort: "evergabe",
    },
  ]
  const evergabe_features = [
    "Gem. VOB/A, VOL/A, UVgO, VgV ausschreiben",
    "Bekanntmachungsformulare nutzen",
    "Vergabeunterlagen einfach hochladen",
    "National und EU-weit veröffentlichen",
    "Elektronische Bieterkommunikation",
    "Rechte- und Rollensystem",
    "Vertreterregelung",
    "Angebotsöffnung mit Vier-Augen-Prinzip",
    "Vergabe mit Losen",
    "Dokumente und Textbausteine speichern",
    "Vergabestatistik",
  ]

  const evergabe_verfahrensarten = [
    "Öffentliche Ausschreibungen",
    "Beschränkte Ausschreibung (mit/ohne Teilnahmewettbewerb)",
    "Freihändige Vergabe (mit/ohne Teilnahmewettbewerb)",
    "Verhandlungsvergabe (mit/ohne Teilnahmewettbewerb)",
    "Offenes Verfahren – EU",
    "Nichtoffenes Verfahren – EU",
  ]

  return (
    <Layout {...{ location, breadcrumb_array }}>
      <SEOComponent
        brand="B_I eVergabe"
        title="Vergabemanagement Software für alle Verfahrensarten konsequent elektronisch"
        description="B_I eVergabe von B_I MEDIEN – Die Webanwendung für den Prozess der elektronischen Vergabe (e-Vergabe) für alle gängigen Vergabeverfahren."
      />
      <div
        className="has-background-mitternachtsblau-5"
        style={{ position: "relative" }}
      >
        <Sparkles {...{ num_particles: 10 }} />
        <div className="container pt-6">
          <h1
            className="title is-1 is-spaced has-text-mitternachtsblau has-text-centered mx-auto my-5"
            style={{ maxWidth: 930 }}
          >
            Noch auf der Suche nach einer einfachen Vergabemanagement-Software
            für die eVergabe?
          </h1>
          <p
            className="has-text-weight-bold has-text-mitternachtsblau has-text-centered mx-auto mb-6"
            style={{ maxWidth: 720 }}
          >
            Mit B_I eVergabe können Sie ganz einfach ausschreiben: Alle Schritte
            der e-Vergabe lassen sich online und unkompliziert mit B_I eVergabe
            abwickeln. Gleich loslegen!
          </p>
          <div
            className="has-text-centered"
            style={{ minHeight: 250, paddingBottom: 50 }}
          >
            <GatsbyImage
              alt="Kostenlose Demo der B_I eVergabe buchen"
              title="Kostenlos B_I eVergabe-Demo buchen"
              image={header_illustration.childImageSharp.gatsbyImageData}
              className="is-hidden-touch"
            />
          </div>

          <div
            className="box is-flex"
            style={{
              minHeight: 105,
              position: "absolute",
              bottom: -50,
              width: "100%",
            }}
          >
            <div className="level my-auto" style={{ width: "100%" }}>
              <div
                title="B_I eVergabe Rollen & Rechtemanagement"
                className="level-item has-text-mitternachtsblau has-text-weight-bold"
              >
                Rechtssicher
              </div>
              <div className="level-item has-text-mitternachtsblau has-text-weight-bold">
                •
              </div>
              <div
                title="B_I eVergabe Rollen & Rechtemanagement"
                className="level-item has-text-mitternachtsblau has-text-weight-bold"
              >
                Webanwendung im Browser
              </div>
              <div className="level-item has-text-mitternachtsblau has-text-weight-bold">
                •
              </div>
              <div
                title="B_I eVergabe Rollen & Rechtemanagement"
                className="level-item has-text-mitternachtsblau has-text-weight-bold"
              >
                Kostenlose Teilnahme für Bieter
              </div>
              <div className="level-item has-text-mitternachtsblau has-text-weight-bold">
                •
              </div>
              <div
                title="B_I eVergabe Rollen & Rechtemanagement"
                className="level-item has-text-mitternachtsblau has-text-weight-bold"
              >
                Rundum-Support
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-5 pt-2">
        <h2 className="title is-1 has-text-centered has-text-mitternachtsblau mx-auto my-6 pt-6">
          Ausschreiben mit B_I eVergabe kann so einfach sein.
          <br /> Hier ist der Beweis.
        </h2>
        <div className="columns is-variable is-6">
          <div className="column">
            <div
              className="box p-6 has-box-shadow-strong"
              style={{ height: "100%" }}
            >
              <h2 className="title has-text-mitternachtsblau is-4">
                Das kann B_I eVergabe
              </h2>

              {evergabe_features.map((feature, index) => {
                return (
                  <div className="is-flex mb-3" key={`ev-feature-${index}`}>
                    <CheckmarkIcon {...{ size: 0.7, color: "#0eaa2d" }} />
                    <p className="has-text-mitternachtsblau ml-3">{feature}</p>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="column">
            <div
              className="box p-6 has-box-shadow-strong"
              style={{ height: "100%" }}
            >
              <h2 className="title has-text-mitternachtsblau is-4">
                Verfahrensarten bei B_I eVergabe
              </h2>
              {evergabe_verfahrensarten.map((feature, index) => {
                return (
                  <div className="is-flex mb-3" key={`feature-vfa-${index}`}>
                    <CheckmarkIcon {...{ size: 0.7, color: "#0eaa2d" }} />
                    <p className="has-text-mitternachtsblau ml-3">{feature}</p>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className="section">
          <div
            className="level is-mobile mr-6 no-scrollbar"
            style={{ overflowX: "auto" }}
          >
            {evSocialProofingImages.nodes.map(({ name, image }, index) => {
              return (
                <div className="level-item " key={`proofin-${index}`}>
                  <GatsbyImage
                    alt={name}
                    title={name}
                    image={image.childImageSharp.gatsbyImageData}
                  />
                </div>
              )
            })}
          </div>
          <p className="has-text-centered pt-4 has-text-mitternachtsblau">
            Mehr als 400 Auftraggeber in ganz Deutschland vertrauen auf
            B_I eVergabe.{" "}
            <Link to="/evergabe/demo-buchen" className="link">
              Gehören auch Sie dazu!
            </Link>
          </p>
        </div>
      </div>

      <div style={{ position: "relative" }}>
        <div
          style={{
            position: "absolute",
            bottom: 0,
            height: 70,
            width: "100%",
          }}
          className="has-background-mitternachtsblau-10"
        ></div>
        <div className="container">
          <div className="box p-6 mx-5 has-box-shadow-strong">
            <p className="title is-1 has-text-mitternachtsblau has-text-centered">
              B_I eVergabe kennenlernen
            </p>
            <p className="has-text-mitternachtsblau has-text-centered mb-6">
              Unser Kundenbetreuer führt Sie gerne durch <br /> unser
              Vergabemanagementsystem.
            </p>
            <div className="has-text-centered mt-5">
              <GatsbyImage
                {...{
                  alt: "Buchen Sie noch heute einen Demotermin!",
                  image: sales_headshot.image.childImageSharp.gatsbyImageData,
                  style: {
                    margin: "auto",
                    borderRadius: "50%",
                    boxShadow: "2px 8px 8px rgba(0, 0, 0, 0.2)",
                  },
                }}
              />
            </div>
            <div className="has-text-centered mt-6">
              <Link to="/evergabe/demo-buchen" className="button is-sonnengelb">
                Kostenlose Demovorführung
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="section has-background-mitternachtsblau-10">
        <div className="columns is-centered mt-5">
          <div className="column is-half">
            <p
              className="title is-1 has-text-mitternachtsblau has-text-centered"
              style={{ maxWidth: 960 }}
            >
              „Mit Features innerhalb und außerhalb der eVergabe-Plattform
              unterstützen wir Sie während der gesamten elektronischen Vergabe.“
            </p>
          </div>
        </div>
        <div className="columns is-centered is-vcentered mt-5">
          <div className="column is-1"></div>
          <div className="column is-1">
            <GatsbyImage
              alt="Grimm"
              imgStyle={{ borderRadius: "50%" }}
              image={ceoImage.childImageSharp.gatsbyImageData}
            />
          </div>
          <div className="column is-2">
            <GatsbyImage
              alt="Grimm"
              image={signatureMockup.childImageSharp.gatsbyImageData}
            />
          </div>
        </div>
        <div className="columns is-centered mb-5 ">
          <div className="column is-2 has-text-mitternachtsblau">
            <p>Lasse Lommel, Geschäftsführer</p>
            <p>B_I MEDIEN</p>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="section mt-6 pt-6" id="vergabestatistik">
          <div className="columns is-centered is-vcentered is-flex-direction-row-reverse">
            <div className="column is-6 has-text-centered">
              <GatsbyImage
                alt="Vergabestatistik"
                title="Vergabestatistik"
                image={vergabestatistikImage.childImageSharp.gatsbyImageData}
              />
            </div>
            <div className="column is-6">
              <div className="tag is-rounded is-success is-small mb-4">
                Jetzt neu
              </div>
              <h2 className="title is-1 has-text-mitternachtsblau">
                Vergabestatistik in B_I eVergabe
              </h2>

              <p className="has-text-mitternachtsblau has-text-weight-bold">
                Damit können Sie Ihre Vergaben direkt aus B_I eVergabe heraus an
                das Statistische Bundesamt (Destatis) melden. Gleichzeitig
                behalten Sie jederzeit den Überblick über offene, deaktivierte
                oder bereits versendete Meldungen zu Ihren Verfahren. So haben
                Sie alles zentral an einem Ort und sparen Zeit und Aufwand.
              </p>
            </div>
          </div>
        </div>

        <div className="section mt-6 pt-6" id="formularsaetze">
          <div className="columns is-centered">
            <div className="column is-6 has-text-centered">
              <GatsbyImage
                alt="Direkt loslegen dank integrierter Formularsätze"
                title="Direkt loslegen dank integrierter Formularsätze"
                image={
                  integrierteFormulareImage.childImageSharp.gatsbyImageData
                }
              />
            </div>
            <div className="column is-6" id="formulare">
              <h2 className="title is-1 has-text-mitternachtsblau">
                Direkt loslegen dank <br />
                integrierter Formularsätze
              </h2>
              <Accordion {...{ tabs: FomularsätzeAccordionTabs }} />
            </div>
          </div>
        </div>


        <div className="section mt-6 pt-6" id="rechtskonforme-fristen">
          <div className="columns is-centered is-vcentered is-flex-direction-row-reverse">
            <div className="column is-6 has-text-centered">
              <GatsbyImage
                alt="Rechtskonforme Fristen und Termine setzen"
                title="Rechtskonforme Fristen und Termine setzen"
                image={termineUndFristenImage.childImageSharp.gatsbyImageData}
              />
            </div>
            <div className="column is-6">
              <h2 className="title is-1 has-text-mitternachtsblau">
                Rechtskonforme Fristen und <br />
                Termine setzen
              </h2>

              <p className="has-text-weight-bold has-text-mitternachtsblau">
                In einem Vergabeverfahren müssen Termine wie Ende der
                Angebotsabgabe, Submissionstermin und Bindefrist korrekt gewählt
                werden. B_I eVergabe hilft Ihnen bei der rechtskonformen
                Festlegung unter Wahrung von gesetzlichen (Mindest-)Fristen.
              </p>
            </div>
          </div>
        </div>


        <div className="section mt-6 pt-6" id="einfache-veroeffentlichung">
          <div className="columns is-centered is-vcentered">
            <div className="column is-6 has-text-centered">
              <GatsbyImage
                alt="Veröffentlichung auf Knopfdruck"
                title="Veröffentlichung auf Knopfdruck"
                image={
                  veroeffentlichungAufKnopfdruckImage.childImageSharp
                    .gatsbyImageData
                }
              />
            </div>
            <div className="column is-6">
              <h2 className="title is-1 has-text-mitternachtsblau">
                Veröffentlichung auf Knopfdruck
              </h2>

              <p className="has-text-weight-bold has-text-mitternachtsblau">
                Ihre fertige Bekanntmachung wird automatisiert bei den
                B_I ausschreibungsdiensten veröffentlicht.
              </p>
              <br />
              <p className="has-text-weight-bold has-text-mitternachtsblau">
                Darüber hinaus können Sie Ihre Bekanntmachung an weitere
                Plattformen zur Veröffentlichung senden.
              </p>
            </div>
          </div>
        </div>


        <div className="section mt-6 pt-6" id="uebermittlung-ted">
          <div className="columns is-centered is-vcentered is-flex-direction-row-reverse">
            <div className="column is-6 has-text-centered ">
              <GatsbyImage
                alt="Direkte Übermittlung an TED und bund.de"
                title="Direkte Übermittlung an TED und bund.de"
                image={uebermittlungTedImage.childImageSharp.gatsbyImageData}
              />
            </div>
            <div className="column is-6">
              <h2 className="title is-1 has-text-mitternachtsblau">
                Direkte Über&shy;mittlung an TED und bund.de
              </h2>

              <p className="has-text-weight-bold has-text-mitternachtsblau">
                Integrierte Schnittstellen übernehmen die Übermittlung Ihrer
                Bekanntmachungen an die TED-Datenbank der EU sowie an die
                Plattform bund.de.
              </p>
            </div>
          </div>
        </div>

        <div className="section mt-6 pt-6" id="bieterkommunikation">
          <div className="columns is-centered is-vcentered">
            <div className="column is-6 has-text-centered">
              <GatsbyImage
                alt="Elektronisch mit Bietern kommunizieren"
                title="Elektronisch mit Bietern kommunizieren"
                image={bieterkommunikationImage.childImageSharp.gatsbyImageData}
              />
            </div>
            <div className="column is-6">
              <h2 className="title is-1 has-text-mitternachtsblau">
                Elektronisch mit Bietern <br />
                kommunizieren
              </h2>
              <p className="has-text-weight-bold has-text-mitternachtsblau">
                Verschicken Sie Nachrichten an einen oder mehrere Bieter,
                beantworten Sie Bieterfragen und teilen Sie die Antworten mit
                allen Bietern. Die gesamte Kommunikation mit den Bietern wird
                zusammen mit dem Verfahren dokumentiert.
              </p>
            </div>
          </div>
        </div>

        <div className="section mt-6 pt-6">
          <div className="columns is-flex-direction-row-reverse">
            <div className="column is-6 has-text-centered">
              <GatsbyImage
                alt="Wählen Sie das beste Angebot aus"
                title="Wählen Sie das beste Angebot aus"
                image={angebotsbewertungImage.childImageSharp.gatsbyImageData}
              />
            </div>
            <div className="column is-6" id="pruefung-wertung">
              <h2 className="title is-1 has-text-mitternachtsblau">
                Wählen Sie das beste Angebot aus
              </h2>
              <Accordion {...{ tabs: AngebotswertungAccordionTabs }} />
            </div>
          </div>
        </div>


        <div className="section mt-6 pt-6" id="doku-rechtsschutz">
          <div className="columns is-vcentered">
            <div className="column is-6">
              <GatsbyImage
                alt="Verfahren dokumentieren und archivieren"
                title="Verfahren dokumentieren und archivieren"
                image={dokumentierenImage.childImageSharp.gatsbyImageData}
              />
            </div>

            <div className="column is-6">
              <h2
                className="title is-1 has-text-mitternachtsblau"
                id="elektronisches-vergabemanagement"
              >
                Verfahren dokum&shy;entieren und archivieren
              </h2>

              <p className="has-text-weight-bold has-text-mitternachtsblau">
                Sie können Ihre Vergabeentscheidung zum Abschluss des Verfahrens
                direkt dokumentieren. Wenn Sie mögen, laden Sie ein zip-Archiv
                mit allen Daten und Dokumenten zur Vergabe herunter.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="section has-background-mitternachtsblau-10">
        <div className="container has-text-centered py-6">
          <div className="has-text-centered my-6">
            <h2 className="title is-1 has-text-mitternachtsblau">
              Wie viel soll B_I eVergabe kosten?
            </h2>
            <p
              className="has-text-centered has-text-mitternachtsblau mx-auto"
              style={{ maxWidth: 960 }}
            >
              Sie schreiben nur selten öffentliche Aufträge aus? Kein Problem!
              Wir haben unterschiedliche Preismodelle für unterschiedliche
              Anforderungen. Gerne beraten wir Sie bei der Wahl des passenden
              Preismodells.
            </p>
            <Link to="/evergabe/preise" className="button is-sonnengelb mt-6">
              Zu unseren Preismodellen
            </Link>
            <div className="columns is-centered mt-6">
              <div className="column is-6">
                <div
                  data-nosnippet
                  className="wistia_responsive_wrapper"
                  style={{
                    height: 365,
                  }}
                >
                  <iframe
                    src="https://fast.wistia.net/embed/iframe/1uyt3fcqea?videoFoam=true&seo=false"
                    title="B_I eVergabe Produktvideo"
                    allow="autoplay; fullscreen"
                    frameBorder="0"
                    scrolling="no"
                    className="wistia_embed"
                    name="wistia_embed"
                    allowFullScreen
                    msallowfullscreen="true"
                    width="100%"
                    height="100%"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <EvergabeWhitepaper />
    </Layout>
  )
}

export default ProduktEvergabe

export const query = graphql`
  {
    sales_headshot: biEmployee(name: { eq: "André Gross" }) {
      image {
        childImageSharp {
          gatsbyImageData(
            width: 95
            formats: [AUTO, AVIF]
            layout: CONSTRAINED
            placeholder: BLURRED
          )
        }
      }
    }
    angebotsbewertungImage: file(name: { eq: "angebotsbewertung" }) {
      childImageSharp {
        gatsbyImageData(
          width: 400
          formats: [AUTO, AVIF]
          layout: CONSTRAINED
          placeholder: BLURRED
        )
      }
    }
    bieterkommunikationImage: file(name: { eq: "bieterkommunikation" }) {
      childImageSharp {
        gatsbyImageData(
          width: 400
          formats: [AUTO, AVIF]
          layout: CONSTRAINED
          placeholder: BLURRED
        )
      }
    }
    dokumentierenImage: file(name: { eq: "dokumentieren" }) {
      childImageSharp {
        gatsbyImageData(
          width: 400
          formats: [AUTO, AVIF]
          layout: CONSTRAINED
          placeholder: BLURRED
        )
      }
    }
    integrierteFormulareImage: file(name: { eq: "integrierte-formulare" }) {
      childImageSharp {
        gatsbyImageData(
          width: 400
          formats: [AUTO, AVIF]
          layout: CONSTRAINED
          placeholder: BLURRED
        )
      }
    }
    termineUndFristenImage: file(name: { eq: "termine-und-fristen" }) {
      childImageSharp {
        gatsbyImageData(
          width: 400
          formats: [AUTO, AVIF]
          layout: CONSTRAINED
          placeholder: BLURRED
        )
      }
    }
    uebermittlungTedImage: file(name: { eq: "uebermittlung-ted" }) {
      childImageSharp {
        gatsbyImageData(
          width: 400
          formats: [AUTO, AVIF]
          layout: CONSTRAINED
          placeholder: BLURRED
        )
      }
    }
    veroeffentlichungAufKnopfdruckImage: file(
      name: { eq: "veroeffentlichung-auf-knopfdruck" }
    ) {
      childImageSharp {
        gatsbyImageData(
          width: 400
          formats: [AUTO, AVIF]
          layout: CONSTRAINED
          placeholder: BLURRED
        )
      }
    }
    vergabestatistikImage: file(name: { eq: "vergabestatistik" }) {
      childImageSharp {
        gatsbyImageData(
          width: 400
          formats: [AUTO, AVIF]
          layout: CONSTRAINED
          placeholder: BLURRED
        )
      }
    }
    header_illustration: file(
      name: { eq: "evergabe-footer-toned-down-desktop" }
    ) {
      childImageSharp {
        gatsbyImageData(
          width: 1300
          quality: 100
          formats: [AUTO, AVIF]
          layout: CONSTRAINED
          placeholder: BLURRED
        )
      }
    }
    ceoImage: file(name: { eq: "lommel-square" }) {
      childImageSharp {
        gatsbyImageData(
          width: 105
          height: 105
          formats: [AUTO, AVIF]
          layout: CONSTRAINED
          placeholder: BLURRED
        )
      }
    }
    signatureMockup: file(name: { eq: "signature-mockup" }) {
      childImageSharp {
        gatsbyImageData(
          width: 190
          formats: [AUTO, AVIF]
          layout: CONSTRAINED
          placeholder: BLURRED
        )
      }
    }
    evSocialProofingImages: allEvergabeSocialProof {
      nodes {
        name
        image {
          childImageSharp {
            gatsbyImageData(
              height: 50
              formats: [AUTO, AVIF]
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
      }
    }
  }
`
